function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { buildPages } from "../utils";
import { A4_MM_DIMENSION } from "../enums";
import { insertTableOfContents } from "../utils";
class DocumentManager {
    reset() {
        this.sections = [];
        this.children = [];
    }
    updateSection(sectionIndex = 0, nextAttrs = {}) {
        const prevAttrs = this.sections[sectionIndex];
        this.sections[sectionIndex] = _object_spread({}, prevAttrs, nextAttrs);
    }
    loadSections(sections = []) {
        sections = sections.length ? sections : this.getSections();
        if (!sections) return;
        // returns sanitized sections with spliced Table of Contents
        sections = insertTableOfContents(sections);
        const [nextSections, children] = buildPages(sections, this.margin);
        this.sections = nextSections;
        this.children = children;
    }
    syncSections(next) {
        const prev = this.getSections();
        if (!prev) return next;
        const length = Math.min(prev.length, next.length);
        for(let index = 0; index < length; index++){
            if (next[index].id === prev[index].id) {
                next[index].pageNumber = prev[index].pageNumber;
            }
        }
        return next;
    }
    handleResize(ref = {}, callback = ()=>{}) {
        if (!ref || !(ref === null || ref === void 0 ? void 0 : ref.current)) return;
        const canvasWidth = ref.current.clientWidth;
        // Convert millimeters to pixels
        const A4WidthInPixels = A4_MM_DIMENSION.WIDTH * (96 / 25.4) * 1.5;
        const scale = Math.min(canvasWidth / A4WidthInPixels, 1);
        callback(scale);
    }
    attachResizeListener(ref, callback) {
        this.resizeHandler = ()=>this.handleResize(ref, callback);
        this.resizeHandler(); // run once on mount
        window.addEventListener("resize", this.resizeHandler);
    }
    cleanup() {
        window.removeEventListener("resize", this.resizeHandler);
    }
    getSections() {
        return this.sections.slice();
    }
    getChildren() {
        return this.children.slice();
    }
    constructor({ margin = 25 }){
        this.sections = [];
        this.children = [];
        this.resizeHandler = this.handleResize.bind(this);
        this.margin = margin;
    }
}
/**
 * DocumentManager class that handles the organization and structure of a document.
 * It manages the ordering of sections and handles page breaks, providing
 * a comprehensive solution for document layout and structure manipulation.
 * DocumentManager also provides a reset functionality that clears all the sections
 * and child elements from the document.
 *
 * @param {Object} options Object containing the configuration parameters for the DocumentManager.
 * @param {number} options.margin Page break buffer size. It is used in calculating the number of section items that fit on a page. Defaults to 25.
 */ export { DocumentManager as default };
